// Task utility functions
export const getTaskStatusColor = (status) => {
  switch (status.toLowerCase()) {
    case 'incoming':
      return '#d97706';
    case 'in-progress':
      return '#17a2b8';
    case 'resolved':
      return '#28a745';
    case 'rejected':
      return '#dc3545';
    default:
      return '#6c757d';
  }
};

export const getPriorityColor = (priority) => {
  switch (priority?.toLowerCase()) {
    case 'critical':
      return '#dc3545';
    case 'high':
      return '#fd7e14';
    case 'medium':
      return '#ffc107';
    case 'low':
      return '#28a745';
    default:
      return '#6c757d';
  }
};

export const getPriorityIcon = (priority) => {
  switch (priority?.toLowerCase()) {
    case 'critical':
      return '!';
    case 'high':
      return '!';
    case 'medium':
      return '';
    case 'low':
      return '';
    default:
      return '';
  }
};

export const getTaskTypeIcon = (taskType) => {
  return taskType === 'customer' ? 'C' : 'T';
};

export const getTaskTypeLabel = (taskType) => {
  return taskType === 'customer' ? 'Customer Request' : 'Task';
}; 